<div class="scanner-wrapper">
  @if (this.scannerConfig) {
    <barcode-scanner-livestream
      [config]="scannerConfig"
      (valueChanges)="onValueChanges($event)"
      [type]="['ean']"
      [torch]="true"
      (started)="onStarted($event)">
    </barcode-scanner-livestream>
  }
  <div class="scanner-overlay">
    <div class="scanner-window"></div>
  </div>
</div>

@if (continuous) {
  <div class="mt-4 flex items-center gap-3">
    <span class="loading loading-ring loading-sm text-success"></span>
    <div class="min-w-0">
      <div class="text-xs font-semibold uppercase tracking-[0.3em] text-base-content/60">Scanning…</div>
      <div class="font-mono text-base truncate">Last: {{ proposedCode || '—' }}</div>
    </div>
  </div>
} @else {
  <div class="mt-4 flex items-center justify-between gap-3">
    <div class="min-w-0">
      <div class="text-xs font-semibold uppercase tracking-[0.3em] text-base-content/60">Proposed</div>
      <div class="font-mono text-base truncate">{{ proposedCode || '—' }}</div>
    </div>

    <button
      type="button"
      class="btn btn-success"
      (click)="acceptedCode()"
      [disabled]="!canAccept">
      Accept
    </button>
  </div>
}
